import { OnInit, OnDestroy, Component } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-download-maturity-links',
    templateUrl: './dojo-download-maturity-links.component.html'
})
export class DojoDownloadMaturityLinksComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    constructor(private contextService: IContextService,
                private router: Router,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService) {
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.renderDojoWidget();

        });
    }

    ngOnDestroy(): void {
        console.log('In Dojo download links Component destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyDownloadMaturityLinks();
        }
    }
    renderDojoWidget() {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderDownloadMaturityLinks();
        }
    }
}
